"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHotToast = require("react-hot-toast");

/** @deprecated The <Flash> component is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use <Toaster>: https://react-hot-toast.com/docs/toaster */
const Flash = () => {
  console.warn('The <Flash> component is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use <Toaster>: https://react-hot-toast.com/docs/toaster');
  return /*#__PURE__*/_react.default.createElement(_reactHotToast.Toaster, null);
};

var _default = Flash;
exports.default = _default;